import React from 'react'
import Modal from '../../../commons/Modal'

interface ThankYouModalProps {
  closeModal: () => any
  object?: string
}

const ThankYouModal: React.FC<ThankYouModalProps> = ({ closeModal, object }) => (
  <Modal title="GRAZIE!" onClose={closeModal}>
    {object === 'withdrawalRequest'
      ? 'La richiesta è stata inviata'
      : 'La richiesta è stata inviata, la elaboreremo appena possibile'}
  </Modal>
)

export default ThankYouModal
